import action from '../helpers/rest-client'

export class ErrorContent extends Error { }

class Content {
  public getAllContentsStatics() {
    return action
      .Get({
        url: '/content/statics',
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAllGeolocations() {
    return action
      .Get({
        url: '/geolocation',
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAllCustomers(filters) {
    const filtersJSON = filters ? `?filters=${JSON.stringify(filters)}` : '';

    return action
      .Get({
        url: `/customer/statics/${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAllUsers() {
    return action
      .Get({
        url: '/user/statics',
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getAllResponsibles() {
    return action
      .Get({
        url: '/responsible/statics',
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const content = new Content()
export default content
